// Core Angular
import angular from 'angular';
import angularPl from './angular-pl';
import ngSanitizeModuleName from 'angular-sanitize';

// Libs
import angularTooltips from 'angular-tooltips';
import './tooltips/tooltips.scss';
import uiRouter from '@uirouter/angularjs';
import hmTouchEvents from 'angular-hammer';
import 'simplebar'; // or "import SimpleBar from 'simplebar';" to use it manually.
import './simplebar/simplebar.scss';

// Services
import FullPageLoaderService from './fullpageloader/fullpageloader.service';
import SubmitOnChangeService from './commons/submitonchange/submitonchange.service';
import CartService from './cart/cart.service';
import SnackbarService from './snackbar/snackbar.service';
import SearchAutocompleteService from './searchautocomplete/searchautocomplete.service';
import GlsService from './cart/shipments/gls.service';
import PaczkomatyService from './cart/shipments/paczkomaty.service';
import ModalService from './commons/modal/modal.service';
import RentalService from './rental/rental.service';

// Directives
import DropdownDirective from './commons/dropdown/dropdown.directive';
import TabsDirective from './commons/tabs/tabs.directive';
import SliderDirective from './commons/slider/slider.directive';
import SubmitOnChangeDirective from './commons/submitonchange/submitonchange.directive';
import ElementWidthDirective from './commons/elementwidth/elementwidth.directive';
import ElementHeightDirective from './commons/elementheight/elementheight.directive';
import InputAutosizeDirective from './commons/inputautosize/inputautosize.directive';
import AllowOnlyNumbersDirective from './commons/allowonlynumbers/allowonlynumbers.directive';
import AutocompleteDirective from './commons/autocomplete/autocomplete.directive';
import PostCodeDirective from './commons/postcode/postcode.directive';
import ModalToggleDirective from './commons/modal/modaltoggle.directive';
import ClickOutsideDirective from './commons/clickoutside/clickoutside.directive';
import SelectPageUrlDirective from './commons/selectpageurl/selectpageurl.directive';
import SelectToDropdownDirective from './commons/selecttodropdown/selecttodropdown.directive';
import FixedHeaderDirective from './commons/fixedheader/fixedheader.directive';
import SimpleBarScrollToDirective from './commons/simplebarscrollto/simplebarscrollto.directive';
import FlatpickrDirective from './commons/flatpickr/flatpickr.directive';

// Filters
import fromMap from './commons/frommap/frommpa.filter';

// Components
import fullPageLoaderComponent from './fullpageloader/fullpageloader.component';
import galleryComponent from './commons/gallery/gallery.component';
import webShareButtonComponent from './commons/websharebutton/websharebutton.component';
import cartItemsComponent from './cart/cartitems.component';
import cartPaymentAndShipmentComponent from './cart/cartpaymentandshipment.component';
import cartSummaryComponent from './cart/cartsummary.component';
import cartDropdownComponent from './cart/cartdrodown.component';
import cartControlsComponent from './cart/cartcontrols.component';
import cartCountComponent from './cart/cartcount.component';
import glsComponent from './cart/shipments/gls.component';
import paczkomatyComponent from './cart/shipments/paczkomaty.component';
import searchAutocompleteComponent from './searchautocomplete/searchautocomplete.component';
import priceFilterComponent from './pricefilter/pricefilter.component';
import selectedFiltersComponent from './selectedfilters/selectedfilters.component';
import snackbarComponent from './snackbar/snackbar.component';
import productViewComponent from './productview/productview.component';
import productViewAvailabilityQuestionComponent from './productview/productviewavailabilityquestion.component';
import productReviewComponent from './productreview/productreview.component';
import productReviewAddComponent from './productreview/productreviewadd.component';
import categoryDescriptionComponent from './category/categorydescription.component';
import modalComponent from './commons/modal/modal.component';
import modalsComponent from './commons/modal/modals.component';
import cartDataSummaryComponent from './cart/cartdatasummary.component';
import cartDataNotLoggedComponent from './cart/cartdatanotlogged.component';
import cartDataLoggedComponent from './cart/cartdatalogged.component';
import cartStepComponent from './cart/cartstep.component';
import cartAddNewAddressComponent from './cart/cartaddnewaddress.component';
import rentalComponent from './rental/rental.component';

const dependencies = [
    ngSanitizeModuleName,
    uiRouter,
    angularTooltips,
    hmTouchEvents
];

const dobraZimaApp = angular.module('dobrazima', dependencies)
    .service('FullPageLoaderService', FullPageLoaderService)
    .service('SubmitOnChangeService', SubmitOnChangeService)
    .service('CartService', CartService)
    .service('SnackbarService', SnackbarService)
    .service('SearchAutocompleteService', SearchAutocompleteService)
    .service('GlsService', GlsService)
    .service('PaczkomatyService', PaczkomatyService)
    .service('ModalService', ModalService)
    .service('RentalService', RentalService)
    .filter('fromMap', fromMap)
    .directive('dropdown', DropdownDirective.directiveFactory)
    .directive('tabs', TabsDirective.directiveFactory)
    .directive('slider', SliderDirective.directiveFactory)
    .directive('submitOnChange', SubmitOnChangeDirective.directiveFactory)
    .directive('elementWidth', ElementWidthDirective.directiveFactory)
    .directive('elementHeight', ElementHeightDirective.directiveFactory)
    .directive('inputAutosize', InputAutosizeDirective.directiveFactory)
    .directive('allowOnlyNumbers', AllowOnlyNumbersDirective.directiveFactory)
    .directive('autocomplete', AutocompleteDirective.directiveFactory)
    .directive('postCode', PostCodeDirective.directiveFactory)
    .directive('modalToggle', ModalToggleDirective.directiveFactory)
    .directive('clickOutside', ClickOutsideDirective.directiveFactory)
    .directive('selectPageUrl', SelectPageUrlDirective.directiveFactory)
    .directive('selectToDropdown', SelectToDropdownDirective.directiveFactory)
    .directive('fixedHeader', FixedHeaderDirective.directiveFactory)
    .directive('simpleBarScrollTo', SimpleBarScrollToDirective.directiveFactory)
    .directive('flatpickr', FlatpickrDirective.directiveFactory)
    .component('fullPageLoader', fullPageLoaderComponent)
    .component('gallery', galleryComponent)
    .component('webShareButton', webShareButtonComponent)
    .component('cartItems', cartItemsComponent)
    .component('cartPaymentAndShipment', cartPaymentAndShipmentComponent)
    .component('cartSummary', cartSummaryComponent)
    .component('cartDropdown', cartDropdownComponent)
    .component('cartControls', cartControlsComponent)
    .component('cartCount', cartCountComponent)
    .component('shipmentGls', glsComponent)
    .component('shipmentPaczkomaty', paczkomatyComponent)
    .component('searchAutocomplete', searchAutocompleteComponent)
    .component('priceFilter', priceFilterComponent)
    .component('selectedFilters', selectedFiltersComponent)
    .component('snackbar', snackbarComponent)
    .component('productView', productViewComponent)
    .component('productViewAvailabilityQuestion', productViewAvailabilityQuestionComponent)
    .component('productReview', productReviewComponent)
    .component('productReviewAdd', productReviewAddComponent)
    .component('categoryDescription', categoryDescriptionComponent)
    .component('modal', modalComponent)
    .component('modals', modalsComponent)
    .component('cartDataSummary', cartDataSummaryComponent)
    .component('cartDataNotLogged', cartDataNotLoggedComponent)
    .component('cartDataLogged', cartDataLoggedComponent)
    .component('cartStep', cartStepComponent)
    .component('cartAddNewAddress', cartAddNewAddressComponent)
    .component('rental', rentalComponent);

dobraZimaApp.config([
    '$locationProvider', '$urlMatcherFactoryProvider', '$stateProvider', '$urlRouterProvider',
    function ($locationProvider, $urlMatcherFactoryProvider, $stateProvider, $urlRouterProvider) {

        $urlMatcherFactoryProvider.strictMode(false);

        $locationProvider.html5Mode({
            enabled: true,
            rewriteLinks: false,
            requireBase: false
        });

        $stateProvider.state('cart', {
            url: '/koszyk',
            views: {
                'cart': {
                    component: 'cartItems',
                },
                'paymentAndShipment': {
                    component: 'cartPaymentAndShipment',
                },
                'summary': {
                    component: 'cartSummary',
                }
            }
        });

        $stateProvider.state('cart-data', {
            url: '/koszyk/twoje-dane',
            views: {
                'summary': {
                    component: 'cartDataSummary',
                }
            }
        });

        $stateProvider.state('rental', {
            url: '/centrum-testowe-wypozyczalnia/:productSlug',
            views: {
                'rental': {
                    component: 'rental',
                }
            },
            resolve: {
                productSlug: $transition$ => $transition$.params().productSlug
            }
        });
    }
]);